import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
	List,
	ListItemText,
	ListItemButton,
	ListItemIcon,
	ListItemSecondaryAction,
	Grid,
	Collapse,
	TextField,
} from "@mui/material";
import Session from "../../store/session";
import useStore from "../../store/store";
import Confirm from "../../components/Confirm";
import PageHeading from "../../components/PageHeading";
import style from "../../utils/style";
import constants from "../../utils/constants";
import Heading from "../../controls/Heading";

function Settings() {
	const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
	const [openContactDialog, setOpenContactDialog] = useState(false);
	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
	let { isLoggedIn, setInfoMessage } = useStore((state) => state);
	const navigate = useNavigate();

	const chevron = (
		<ion-icon name="chevron-forward-outline" color="medium"></ion-icon>
	);
	const chevronUp = (
		<ion-icon name="chevron-up-outline" color="medium"></ion-icon>
	);
	const chevronDown = (
		<ion-icon name="chevron-down-outline" color="medium"></ion-icon>
	);

	useEffect(() => {
		if (!isLoggedIn) navigate("/login");
	}, []);

	const handleContactUs = () => {
		setOpenContactDialog(false);
		window.location.href = "tel:03287877378";
	};

	const handleShare = () => {
		navigator.clipboard.writeText(process.env.REACT_APP_PUBLIC_URL);
		setInfoMessage("App link copied to clipboard");
	};

	const handleLogout = () => {
		setOpenLogoutDialog(false);
		Session.logout();
		window.location.href = "/login";
	};

	return (
		<>
			<Confirm
				open={openContactDialog}
				onNo={() => setOpenContactDialog(false)}
				onYes={() => {
					handleContactUs();
				}}
				title="Contact admin via call"
				body="Call 0328-7877378 to discuss any issue"
			/>

			<Confirm
				open={openLogoutDialog}
				onNo={() => setOpenLogoutDialog(false)}
				onYes={() => {
					handleLogout();
				}}
				title="Want to logout?"
				body="You'll be logged out from the application"
			/>

			<Grid container sx={style.container}>
				<Grid item xs={12} sx={{ mb: 0 }}>
					<PageHeading text="Settings" />
				</Grid>
				<Grid item xs={12} md={12}>
					<List
						sx={{
							width: "100%",
							bgcolor: "background.paper",
							p: 0,
							m: 0,
						}}
					>
						<ListItemButton component={Link} to="/profile">
							<ListItemSecondaryAction>
								{chevron}
							</ListItemSecondaryAction>
							<ListItemIcon>
								<ion-icon
									name="person-outline"
									size={style.settingIcons}
									style={{ color: constants.PRIMARY }}
								></ion-icon>
							</ListItemIcon>
							<ListItemText
								primary="Profile"
								secondary="See your profile data"
							/>
						</ListItemButton>

						<ListItemButton component={Link} to="/changePassword">
							<ListItemSecondaryAction>
								{chevron}
							</ListItemSecondaryAction>
							<ListItemIcon>
								<ion-icon
									name="repeat"
									size={style.settingIcons}
									style={{ color: constants.PRIMARY }}
								></ion-icon>
							</ListItemIcon>
							<ListItemText
								primary="Change Password"
								secondary="Change your login password"
							/>
						</ListItemButton>

						<ListItemButton component={Link} to="/stocks">
							<ListItemSecondaryAction>
								{chevron}
							</ListItemSecondaryAction>
							<ListItemIcon>
								<ion-icon
									name="grid-outline"
									size={style.settingIcons}
									style={{
										color: constants.PRIMARY,
									}}
								></ion-icon>
							</ListItemIcon>
							<ListItemText
								primary="Stocks"
								secondary="View & manage stock"
							/>
						</ListItemButton>

						<ListItemButton component={Link} to="/users">
							<ListItemSecondaryAction>
								{chevron}
							</ListItemSecondaryAction>
							<ListItemIcon>
								<ion-icon
									name="people-outline"
									size={style.settingIcons}
									style={{
										color: constants.PRIMARY,
									}}
								></ion-icon>
							</ListItemIcon>
							<ListItemText
								primary="Users"
								secondary="List of users that work with you"
							/>
						</ListItemButton>

						<ListItemButton component={Link} to="/chart">
							<ListItemSecondaryAction>
								{chevron}
							</ListItemSecondaryAction>
							<ListItemIcon>
								<ion-icon
									name="stats-chart-outline"
									size={style.settingIcons}
									style={{
										color: constants.PRIMARY,
									}}
								></ion-icon>
							</ListItemIcon>
							<ListItemText
								primary="Charts"
								secondary="Transactions on a charts"
							/>
						</ListItemButton>

						{/* <ListItemButton component={Link} to="/about-us">
								<ListItemSecondaryAction>{chevron}</ListItemSecondaryAction>
								<ListItemIcon>
									<ion-icon
									name="information-outline"
									size={style.settingIcons}
									style={{ color: constants.PRIMARY }}
									></ion-icon>
								</ListItemIcon>
								<ListItemText
									primary="About Us"
									secondary="Check out our privacy policy"
								/>
							</ListItemButton> */}

						{/* <ListItemButton onClick={() => setOpenContactDialog(true)}>
							<ListItemIcon>
								<ion-icon
								name="help-outline"
								size={style.settingIcons}
								style={{ color: constants.PRIMARY }}
								></ion-icon>
							</ListItemIcon>
							<ListItemText
								primary="Contact Us"
								secondary="Contact us for any queries"
							/>
						</ListItemButton> */}

						<ListItemButton onClick={handleShare}>
							<ListItemIcon>
								<ion-icon
									name="share-social-outline"
									size={style.settingIcons}
									style={{ color: constants.PRIMARY }}
								></ion-icon>
							</ListItemIcon>
							<ListItemText
								primary="Share"
								secondary="Share the app link with friends"
							/>
						</ListItemButton>

						<ListItemButton
							onClick={() => setOpenLogoutDialog(true)}
						>
							<ListItemIcon>
								<ion-icon
									name="log-out-outline"
									size={style.settingIcons}
									style={{ color: constants.PRIMARY }}
								></ion-icon>
							</ListItemIcon>
							<ListItemText
								primary="Logout"
								secondary="Logout from the app"
							/>
						</ListItemButton>

						<ListItemButton
							onClick={() =>
								setOpenDeleteDialog(!openDeleteDialog)
							}
						>
							<ListItemIcon>
								<ion-icon
									name="trash-outline"
									size={style.settingIcons}
									color="danger"
								></ion-icon>
							</ListItemIcon>
							<ListItemText
								primary="Delete Account or Data"
								secondary="Erase all data or delete account"
							/>
							<ListItemSecondaryAction>
								{openDeleteDialog ? chevronUp : chevronDown}
							</ListItemSecondaryAction>
						</ListItemButton>

						<Collapse
							in={openDeleteDialog}
							timeout="auto"
							unmountOnExit
						>
							<List
								component="div"
								disablePadding
								style={{
									textAlign: "center",
								}}
							>
								<Heading
									variant="p"
									text="Contact admin for these actions"
									color="grey"
								/>
							</List>
						</Collapse>
					</List>
				</Grid>
			</Grid>
		</>
	);
}

export default Settings;
